import axios from "axios";

const client = axios.create({
    baseURL: `${import.meta.env.VITE_APP_REFERRALS_ENDPOINT}/ops/public`,
    headers: {
        'Content-Type': 'application/json',
        'api_key': import.meta.env.VITE_REFERRALS_API_KEY,
    },
});

export async function fetchUserRewardInfoAPI(referralCode) {
    try {
        const { data } = await client.get(
            `/${referralCode}/info`,
        );
        return { success: true, rewardInfo: data.data };
    } catch (error) {
        return { success: false, error };
    }
}